import type { Effect } from './effect';

const CLEAR_FILL = '#FFFFFF';

const isHexColor = (v: unknown): v is string =>
  typeof v === 'string' && /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(v);

const resolved = (value: unknown): string | null => {
  if (value === '') return CLEAR_FILL;
  if (isHexColor(value)) return value;
  return null;
};

export const fillColorEffect: Effect = {
  applyToJson(obj, value) {
    const fill = resolved(value);
    if (fill === null) return null;
    return { ...obj, fill };
  },

  async applyToCanvas(obj, value) {
    const fill = resolved(value);
    if (fill === null) return;
    obj.set('fill', fill);
    obj.dirty = true;
  }
};
